import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { ManagerProfileSectionProps } from "./ManagerProfileSection.types";
import { Button } from "../../common/Button";
import { VeriHeading } from "../../common/VeriHeading";
import { useManagerProfile } from "../ManagerProfileProvider";

export const ManagerProfileSection = React.forwardRef<
  HTMLDivElement,
  ManagerProfileSectionProps
>(
  (
    {
      title,
      actionLabel = "Edit",
      titleActions,
      showTitle = true,
      disableEdit = false,
      children,
      action,
      extraActions,
      ...rest
    },
    ref,
  ) => {
    const { isEditing } = useManagerProfile();

    const _actions =
      titleActions ||
      (!!action && (
        <Button
          onClick={action}
          label={actionLabel}
          isDisabled={disableEdit}
          isFlat
        />
      ));

    return (
      <Box ref={ref} {...rest}>
        {showTitle && (
          <Flex alignItems={"center"} mb={4}>
            <VeriHeading textStyle={"h4"} mr={4}>
              {title}
            </VeriHeading>

            {isEditing && <Flex>{_actions}</Flex>}
            {extraActions && (
              <Flex flexGrow={1} justifyContent={"flex-end"}>
                {extraActions}
              </Flex>
            )}
          </Flex>
        )}
        <Box>{children}</Box>
      </Box>
    );
  },
);

ManagerProfileSection.displayName = "ManagerProfileSection";
